<template>
  <section class="w-full flex justify-center text-skin-primary-findrisk">
    <section
      class="max-w-1440 w-full grid grid-cols-4 md:grid-cols-8 lg:grid-cols-12 gap-x-4 lg:gap-x-6 px-16px lg:px-6"
    >
      <section
        class="col-span-full md:col-start-2 md:col-end-8 lg:col-start-3 lg:col-end-11 xl:col-start-4 xl:col-end-10 py-20"
      >
        <section class="flex flex-col items-center gap-y-12">
          <section class="w-full pt-4">
            <section
              class="flex flex-col md:flex-row justify-center gap-6 pt-4"
            >
              <selectable-field
                v-model="genre"
                :placeholder="'Sexo'"
                :itemIdField="'id'"
                :itemDescriptionField="'text'"
                :items="genreOptions"
                ref="genre"
                identity="Sexo"
                label="Sexo"
              />
              <datepicker-field
                v-model="birthdate"
                :placeholder="'Fecha de nacimiento'"
                :itemIdField="'id'"
                :itemDescriptionField="'text'"
                :items="genreOptions"
                ref="birthdate"
                identity="Fecha de Nacimiento"
                label="Fecha de nacimiento"
              />
            </section>
          </section>

          <checks-container
            v-model="mainFeatures.familyBackground"
            :items="items[0]"
            :itemIdField="'id'"
            :itemDescriptionField="'titles'"
            :itemValueField="'value'"
            :title="
              '¿Ha habido un diagnóstico de diabetes por lo menos en un miembro de su familia?'
            "
            ref="familyBackground"
            identity="Antecedentes Familiares"
          />

          <checks-container
            v-if="genre"
            v-model="mainFeatures.weistPerimeter"
            :items="genre.id == 'm' ? items[1] : items[2]"
            :itemIdField="'id'"
            :itemDescriptionField="'titles'"
            :itemValueField="'value'"
            :title="
              '¿Qué perímetro de cintura tiene, medido a nivel del ombligo? '
            "
            :subtitle="
              '(Si no tiene una cinta métrica, use un pedazo de cuerda y ayúdese con una regla)'
            "
            ref="weistPerimeter"
            identity="Perímetro de Cintura"
          />

          <checks-container
            v-model="mainFeatures.physicalActivity"
            :items="items[3]"
            :itemIdField="'id'"
            :itemDescriptionField="'titles'"
            :itemValueField="'value'"
            :title="'¿Tiene actividad física por lo menos 30 minutos diarios?'"
            ref="physicalActivity"
            identity="Actividad Física"
          />

          <checks-container
            v-model="mainFeatures.healthyFoodConsumptionFrecuency"
            :items="items[4]"
            :itemIdField="'id'"
            :itemDescriptionField="'titles'"
            :itemValueField="'value'"
            :title="
              '¿Con que frecuencia come fruta, verduras o vegetales?'
            "
            ref="healthyFoodConsumptionFrecuency"
            identity="Consumo de Comida Saludable"
          />

          <checks-container
            v-model="mainFeatures.hypertensionMedicines"
            :items="items[5]"
            :itemIdField="'id'"
            :itemDescriptionField="'titles'"
            :itemValueField="'value'"
            :title="
              '¿Le han recetado alguna vez medicamentos contra la hipertensión?'
            "
            ref="hypertensionMedicines"
            identity="Medicinas para la Hipertensión"
          />

          <checks-container
            v-model="mainFeatures.bloodGlucose"
            :items="items[6]"
            :itemIdField="'id'"
            :itemDescriptionField="'titles'"
            :itemValueField="'value'"
            :title="
              '¿Le han detectado alguna vez, en un control médico, un nivel muy alto de glucosa (azúcar) en su sangre?'
            "
            ref="bloodGlucose"
            identity="Glucosa"
          />

          <section class="w-full flex flex-col items-center">
            <p class="font-bold text-3xl" v-text="'Añade tu peso y talla'" />
            <section
              class="w-full flex flex-col md:flex-row justify-center gap-6 pt-12"
            >
              <section class="w-full">
                <p
                  class="px-8 text-xl font-medium"
                  v-text="'Peso (kilogramos)'"
                />
                <input-field
                  :rules="{ required: true }"
                  v-model="weight"
                  type="number"
                  placeholder="Peso"
                  class="pt-4"
                  ref="weight"
                  identity="Peso"
                />
              </section>
              <section class="w-full">
                <p class="px-8 text-xl font-medium" v-text="'Talla (metros)'" />
                <input-field
                  :rules="{ required: true }"
                  v-model="size"
                  type="number"
                  placeholder="Talla"
                  class="pt-4"
                  ref="size"
                  identity="Talla"
                />
              </section>
            </section>
            <primary-button
              @click="goToModalForm"
              class="mt-12"
              :text="'Calcular'"
            />
          </section>
        </section>
      </section>
    </section>
    <form-modal @close="goToResult" :data="personData" v-if="showModal" />
  </section>
</template>
<script>
import { mapActions, mapGetters } from "vuex";
import { STORE_NAME_COMPONENTS } from "../../store/modules/components";
import toastr from "toastr";
export default {
  mounted() {
    if (localStorage.getItem("genre"))
      this.genre = JSON.parse(localStorage.getItem("genre"));
    if (localStorage.getItem("size")) this.size = localStorage.getItem("size");
    if (localStorage.getItem("weight"))
      this.weight = localStorage.getItem("weight");
    if (localStorage.getItem("familyBackground"))
      this.mainFeatures.familyBackground = JSON.parse(
        localStorage.getItem("familyBackground")
      );
    if (localStorage.getItem("weistPerimeter"))
      this.mainFeatures.weistPerimeter = JSON.parse(
        localStorage.getItem("weistPerimeter")
      );
    if (localStorage.getItem("physicalActivity"))
      this.mainFeatures.physicalActivity = JSON.parse(
        localStorage.getItem("physicalActivity")
      );
    if (localStorage.getItem("healthyFoodConsumptionFrecuency"))
      this.mainFeatures.healthyFoodConsumptionFrecuency = JSON.parse(
        localStorage.getItem("healthyFoodConsumptionFrecuency")
      );
    if (localStorage.getItem("hypertensionMedicines"))
      this.mainFeatures.hypertensionMedicines = JSON.parse(
        localStorage.getItem("hypertensionMedicines")
      );
    if (localStorage.getItem("bloodGlucose"))
      this.mainFeatures.bloodGlucose = JSON.parse(
        localStorage.getItem("bloodGlucose")
      );
  },
  components: {
    ChecksContainer: () => import("../ChecksContainer.vue"),
    InputField: () => import("../InputField.vue"),
    PrimaryButton: () => import("../PrimaryButton.vue"),
    FormModal: () => import("../FormModal.vue"),
    DatepickerField: () => import("../DatepickerField.vue"),
    SelectableField: () => import("../SelectableField.vue"),
  },
  metaInfo: {
    title: "DIABETES Y TECNOLOGÍA: Juntas para optimizar el buen control",
    titleTemplate: "%s - Dra. Omidres Pérez",
    content: "DIABETES Y TECNOLOGÍA: Juntas para optimizar el buen control",
    meta: [
      {
        name: "DIABETES Y TECNOLOGÍA: Juntas para optimizar el buen control",
        content: "Hagamos viral la salud con la Dra. Omidres Pérez",
        vmid: "Dra Omidres Pérez",
      },
    ],
    htmlAttrs: {
      lang: "es",
      amp: true,
    },
  },
  data: () => ({
    genre: null,
    birthdate: null,
    weight: null,
    size: null,
    mainFeatures: {
      familyBackground: null,
      weistPerimeter: null,
      physicalActivity: null,
      healthyFoodConsumptionFrecuency: null,
      hypertensionMedicines: null,
      bloodGlucose: null,
    },
    items: [
      [
        { id: 0, titles: "No", value: 0 },
        {
          id: 1,
          titles: "Sí, en mis parientes: abuelos, tíos y primos",
          value: 3,
        },
        {
          id: 2,
          titles: "Sí, en mi familia directa: padres, hijos, hermanos",
          value: 5,
        },
      ],
      [
        { id: 0, titles: "Menos de 80 cm", value: 0 },
        { id: 1, titles: "80 hasta 88 cm", value: 3 },
        { id: 2, titles: "Más de 88 cm", value: 4 },
      ],
      [
        { id: 0, titles: "Menos de 94 cm", value: 0 },
        { id: 1, titles: "94 hasta 102 cm", value: 3 },
        { id: 2, titles: "Más de 102 cm", value: 4 },
      ],
      [{ id: 0, titles: "Sí", value: 0 }, { id: 1, titles: "No", value: 2 }],
      [
        { id: 0, titles: "Diario", value: 0 },
        { id: 1, titles: "No diariamente", value: 2 },
      ],
      [{ id: 0, titles: "No", value: 0 }, { id: 1, titles: "Sí", value: 2 }],
      [{ id: 0, titles: "No", value: 0 }, { id: 1, titles: "Sí", value: 5 }],
    ],
    headers: [
      [{ text: "Hombres", width: 220 }, { text: "Mujeres", width: 220 }],
    ],
    genreOptions: [
      {
        id: "h",
        text: "Hombre",
      },
      {
        id: "m",
        text: "Mujer",
      },
    ],
  }),
  methods: {
    ...mapActions(STORE_NAME_COMPONENTS, ["changeShowModal"]),
    validate() {
      const genre = this.$refs.genre.validate();
      const birthdate = this.$refs.birthdate.validate();
      const familyBackground = this.$refs.familyBackground.validate();
      const weistPerimeter = this.$refs.weistPerimeter
        ? this.$refs.weistPerimeter.validate()
        : true;
      const physicalActivity = this.$refs.physicalActivity.validate();
      const healthyFoodConsumptionFrecuency = this.$refs.healthyFoodConsumptionFrecuency.validate();
      const hypertensionMedicines = this.$refs.hypertensionMedicines.validate();
      const bloodGlucose = this.$refs.bloodGlucose.validate();
      const weight = this.$refs.weight.validate();
      const size = this.$refs.size.validate();

      if (
        genre ||
        birthdate ||
        familyBackground ||
        weistPerimeter ||
        physicalActivity ||
        healthyFoodConsumptionFrecuency ||
        hypertensionMedicines ||
        bloodGlucose ||
        weight ||
        size
      )
        toastr.error(
          "Todos los campos son requeridos, por favor revise la información ingresada."
        );

      return (
        genre ||
        birthdate ||
        familyBackground ||
        weistPerimeter ||
        physicalActivity ||
        healthyFoodConsumptionFrecuency ||
        hypertensionMedicines ||
        bloodGlucose ||
        weight ||
        size
      );
    },
    goToResult(_isSuccess) {
      if (_isSuccess) {
        this.changeShowModal(false);
        this.$router.push({
          name: "find-risk-result",
          params: {
            total: this.total,
            mci: this.bodyMassIndex,
            showResults: true,
          },
        });
      }
    },
    goToModalForm() {
      if (!this.validate()) {
        this.changeShowModal(true);
      }
    },
    truncate(number) {
      let newNumber = number.toString();
      let regex = /(\d*.\d{0,2})/;
      return newNumber.match(regex)[0];
    },
  },
  watch: {
    size(_newValue) {
      if (_newValue != null && _newValue != "") {
        this.size = this.truncate(_newValue).replace("-", "");
        localStorage.setItem("size", this.size);
      }
    },
    weight(_newValue) {
      if (_newValue != null && _newValue != "") {
        this.weight = this.truncate(_newValue).replace("-", "");
        localStorage.setItem("weight", this.weight);
      }
    },
    "mainFeatures.familyBackground": function(_newValue) {
      localStorage.setItem("familyBackground", JSON.stringify(_newValue));
    },
    "mainFeatures.weistPerimeter": function(_newValue) {
      localStorage.setItem("weistPerimeter", JSON.stringify(_newValue));
    },
    "mainFeatures.physicalActivity": function(_newValue) {
      localStorage.setItem("physicalActivity", JSON.stringify(_newValue));
    },
    "mainFeatures.healthyFoodConsumptionFrecuency": function(_newValue) {
      localStorage.setItem(
        "healthyFoodConsumptionFrecuency",
        JSON.stringify(_newValue)
      );
    },
    "mainFeatures.hypertensionMedicines": function(_newValue) {
      localStorage.setItem("hypertensionMedicines", JSON.stringify(_newValue));
    },
    "mainFeatures.bloodGlucose": function(_newValue) {
      localStorage.setItem("bloodGlucose", JSON.stringify(_newValue));
    },
    genre(_newValue) {
      localStorage.setItem("genre", JSON.stringify(_newValue));
    },
  },
  computed: {
    ...mapGetters(STORE_NAME_COMPONENTS, ["showModal"]),
    total() {
      let total = 0;

      if (this.bodyMassIndex < 25) {
        total += 0;
      } else if (this.bodyMassIndex >= 25 && this.bodyMassIndex <= 30) {
        total += 1;
      } else if (this.bodyMassIndex >= 30) {
        total += 3;
      }

      if (this.birthdate) {
        let age = this.$date().diff(this.$date(this.birthdate), "year");
        if (age < 35) {
          total += 0;
        } else if (age >= 35 && age <= 44) {
          total += 1;
        } else if (age >= 45 && age <= 54) {
          total += 2;
        } else if (age >= 55 && age <= 64) {
          total += 3;
        } else if (age >= 65) {
          total += 4;
        }
      }

      if (Object.values(this.mainFeatures).every((feature) => feature == null))
        return total;

      Object.values(this.mainFeatures).forEach((feature) => {
        total += feature ? feature.value : 0;
      });

      return total;
    },
    bodyMassIndex() {
      if (!this.weight || !this.size) return 0;
      return this.truncate(
        parseFloat(this.weight) / Math.pow(parseFloat(this.size), 2)
      );
    },
    personData() {
      return {
        totalPoints: this.total,
        bodyMassIndex: this.bodyMassIndex,
        birthdate: this.birthdate,
        genre: this.genre,
      };
    },
  },
};
</script>
